import * as React from "react";
import type { SVGProps } from "react";

const EftsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
      fill="#1C64F2"
    />
    <path
      d="M7.91456 16.1001V11.5091H10.998V12.3094H8.88206V13.4033H10.8394V14.2036H8.88206V15.2998H11.007V16.1001H7.91456Z"
      fill="white"
    />
    <path d="M11.5929 12.3094V11.5091H15.3512V12.3094H13.9502V16.1001H12.9939V12.3094H11.5929Z" fill="white" />
    <path
      d="M15.9701 16.1001V11.5091H19V12.3094H16.9376V13.4033H18.7989V14.2036H16.9376V16.1001H15.9701Z"
      fill="white"
    />
    <path
      d="M6.88763 18H6.25842C5.92466 18 5.60458 17.867 5.36858 17.6302C5.13258 17.3935 5 17.0723 5 16.7375V9.16244C5 8.8276 5.13258 8.50647 5.36858 8.26971C5.60458 8.03294 5.92466 7.89993 6.25842 7.89993H17.5842C17.9179 7.89993 18.238 8.03294 18.474 8.26971C18.71 8.50647 18.8426 8.8276 18.8426 9.16244V10.4249H17.5842V9.16244H6.25842V16.7375H6.88763V18Z"
      fill="white"
    />
    <path d="M14.4129 8.52502H13.1545V7.26251H10.6377V8.52502H9.37927V6H14.4129V8.52502Z" fill="white" />
    <path d="M8.12085 7.26251H6.86243V8.52502H8.12085V7.26251Z" fill="white" />
    <path d="M16.9298 7.26251H15.6714V8.52502H16.9298V7.26251Z" fill="white" />
  </svg>
);

export default EftsIcon;

